import { vecScale } from '../vec/vecScale';
import type { RawMatrix4 } from './RawMatrix4';

/**
 *  an inverse of given mat4.
 */
export function mat4Inverse(m: RawMatrix4): RawMatrix4 {
  const a00 = m[0],
    a01 = m[1],
    a02 = m[2],
    a03 = m[3],
    a10 = m[4],
    a11 = m[5],
    a12 = m[6],
    a13 = m[7],
    a20 = m[8],
    a21 = m[9],
    a22 = m[10],
    a23 = m[11],
    a30 = m[12],
    a31 = m[13],
    a32 = m[14],
    a33 = m[15],
    b00 = a00 * a11 - a01 * a10,
    b01 = a00 * a12 - a02 * a10,
    b02 = a00 * a13 - a03 * a10,
    b03 = a01 * a12 - a02 * a11,
    b04 = a01 * a13 - a03 * a11,
    b05 = a02 * a13 - a03 * a12,
    b06 = a20 * a31 - a21 * a30,
    b07 = a20 * a32 - a22 * a30,
    b08 = a20 * a33 - a23 * a30,
    b09 = a21 * a32 - a22 * a31,
    b10 = a21 * a33 - a23 * a31,
    b11 = a22 * a33 - a23 * a32;

  const det =
    b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (det === 0.0) {
    return vecScale(m, 0.0);
  }

  return vecScale(
    [
      a11 * b11 - a12 * b10 + a13 * b09,
      a02 * b10 - a01 * b11 - a03 * b09,
      a31 * b05 - a32 * b04 + a33 * b03,
      a22 * b04 - a21 * b05 - a23 * b03,
      a12 * b08 - a10 * b11 - a13 * b07,
      a00 * b11 - a02 * b08 + a03 * b07,
      a32 * b02 - a30 * b05 - a33 * b01,
      a20 * b05 - a22 * b02 + a23 * b01,
      a10 * b10 - a11 * b08 + a13 * b06,
      a01 * b08 - a00 * b10 - a03 * b06,
      a30 * b04 - a31 * b02 + a33 * b00,
      a21 * b02 - a20 * b04 - a23 * b00,
      a11 * b07 - a10 * b09 - a12 * b06,
      a00 * b09 - a01 * b07 + a02 * b06,
      a31 * b01 - a30 * b03 - a32 * b00,
      a20 * b03 - a21 * b01 + a22 * b00,
    ],
    1.0 / det,
  );
}
